export abstract class TimedTriggerHandler
{
    public abstract clear(): void;
    public abstract push(delay: number, callback: () => void): void;
}

export class TimeoutTimedTriggerHandler extends TimedTriggerHandler
{
    private readonly timedTriggers: number[] = [];

    public clear(): void
    {
        this.timedTriggers.forEach(timeout => clearTimeout(timeout));
        this.timedTriggers.length = 0;
    }

    public push(delay: number, callback: ()=> void): void
    {
        this.timedTriggers.push(window.setTimeout(callback, delay));
    }
}